var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ],
      staticClass: "grid-view",
      attrs: {
        "element-loading-text": "",
        "element-loading-spinner": "none",
        "element-loading-background": "rgba(170,170,170,0)"
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "app-main-inner-row" }, [
          _c("div", { staticClass: "filters" }),
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.popTemplateTypeAddDialog }
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.btn.new")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.popTemplateTypeEditFormDialog }
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.btn.edit")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "mini" },
                  on: { click: _vm.toBatchDel }
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.btn.delete")) + " ")]
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%" },
              attrs: {
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                "grid-options": _vm.gridOptions,
                "side-bar": _vm.sideBarDefs
              },
              on: { gridReady: _vm.onReady }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                total: _vm.total,
                page: _vm.filter.pageNum,
                limit: _vm.filter.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.filter, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.filter, "pageSize", $event)
                },
                pagination: _vm.loadData
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            slot: "reference",
            "close-on-click-modal": false,
            visible: _vm.isShowTemplateTypeManagementMaintain,
            title: _vm.showTemplateTypeManagementMaintainTitle,
            "inline-message": "",
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowTemplateTypeManagementMaintain = $event
            }
          },
          slot: "reference"
        },
        [
          _c(
            "el-form",
            {
              ref: "templateTypeManagementMaintainForm",
              attrs: {
                model: _vm.templateTypeManagementForm,
                "label-width": "150px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "DEFAULT ENGINE" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.templateTypeManagementForm.defaultEngine,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.templateTypeManagementForm,
                            "defaultEngine",
                            $$v
                          )
                        },
                        expression: "templateTypeManagementForm.defaultEngine"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("V1")]),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("V2")])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "SCHEMA TYPE" } },
                [
                  _c("el-input", {
                    ref: "schemaType",
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.templateTypeManagementForm.schemaType,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.templateTypeManagementForm,
                          "schemaType",
                          $$v
                        )
                      },
                      expression: "templateTypeManagementForm.schemaType"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "TEMPLATE TYPE" } },
                [
                  _c("el-input", {
                    ref: "templateType",
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.templateTypeManagementForm.templateType,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.templateTypeManagementForm,
                          "templateType",
                          $$v
                        )
                      },
                      expression: "templateTypeManagementForm.templateType"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "TEMPLATE TYPE DESC" } },
                [
                  _c("el-input", {
                    ref: "templateTypeDesc",
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.templateTypeManagementForm.templateTypeDesc,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.templateTypeManagementForm,
                          "templateTypeDesc",
                          $$v
                        )
                      },
                      expression: "templateTypeManagementForm.templateTypeDesc"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "REMARKS" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: "2", size: "mini" },
                    model: {
                      value: _vm.templateTypeManagementForm.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.templateTypeManagementForm, "remarks", $$v)
                      },
                      expression: "templateTypeManagementForm.remarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini ", type: "primary" },
                  on: { click: _vm.submitTemplateTypeManagement }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini " },
                  on: { click: _vm.cancelSaveOrEdit }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }